import apiClient from '../../../api/apiClient';
import { USER_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = USER_REST_API_BASE_URL;

export const getLoggedInUserProfile = () =>
  apiClient.get(`${REST_API_BASE_URL}/profile`);

export const getProfileRole = () =>
  apiClient.post(`${REST_API_BASE_URL}/profile/role`);

export default apiClient;
